import { Injectable } from '@angular/core';
import { Subject, Observable, Observer } from 'rxjs';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {

  constructor(private _messageService: MessageService) { }

  private subject: Subject<MessageEvent>;

  public connect(url): Subject<MessageEvent> {
    if (!this.subject) {
      this.subject = this.create(url);
    }
    console.log('Sucessfully connected to ', url);
    return this.subject;
  };

  private create(url): Subject<MessageEvent> {

    let socket = new WebSocket(url);
    let observable = Observable.create(
      (obs: Observer<MessageEvent>) => {
        socket.onmessage = obs.next.bind(obs);
        socket.onerror = obs.error.bind(obs);
        socket.onclose = obs.complete.bind(obs);
        return socket.close.bind(socket);
      }
    );

    let observer = {
      next: (data: object) => {
        if (socket.readyState === WebSocket.OPEN) {
          socket.send(JSON.stringify(data));
        }
      },

      error: (err: any) => {
        this._messageService.displayMessage({ type: 'error', body: err });
      },

      complete: () => {
        socket.close();
      }
    };

    return Subject.create(observer, observable);
  }
}
